<div class="reservation-form-container">
  <p class="form-instructions">
    Por favor, para finalizar tu reserva completa este formulario con tus datos personales:
  </p>

  <form [formGroup]="reservationForm" (ngSubmit)="save()" class="reservation-form">
    <!-- Datos personales -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3">
            <label class="form-label" for="Name">Nombre y apellidos<span aria-hidden="true">*</span><span class="visually-hidden">(obligatorio)</span></label>
            <input type="text" formControlName="Name" id="Name" class="form-control" [class.is-invalid]="submitted && reservationForm.get('Name')?.invalid" [class.is-valid]="submitted && reservationForm.get('Name')?.valid" placeholder="Nombre Apellidos" maxlength="100">
            @if (submitted && reservationForm.get('Name')?.invalid) {
            <div class="invalid-feedback">Este campo es obligatorio</div>
            }
          </div>
        </div>
        <div class="col-md-4 col-xl-3">
          <div class="form-group mb-3">
            <label class="form-label" for="Dni">DNI<span aria-hidden="true">*</span><span class="visually-hidden">(obligatorio)</span></label>
            <input type="text" formControlName="Dni" id="Dni" class="form-control" [class.is-invalid]="submitted && reservationForm.get('Dni')?.invalid" [class.is-valid]="submitted && reservationForm.get('Dni')?.valid" placeholder="DNI" maxlength="9" autocomplete="off" autocapitalize="characters" inputmode="text" pattern="(?:[0-9]{8}[A-Za-z]|[XxYyZz][0-9]{7}[A-Za-z])" (input)="onDniInput($event)">
            @if (submitted && reservationForm.get('Dni')?.errors?.['required']) {
            <div class="invalid-feedback">Este campo es obligatorio</div>
            }
            @if (submitted && reservationForm.get('Dni')?.errors?.['pattern']) {
            <div class="invalid-feedback">Introduce un DNI válido (8 números y letra, o NIE)</div>
            }
          </div>
        </div>
        <div class="col-md-4 col-xl-3">
          <div class="form-group mb-3">
            <label class="form-label" for="Phone">Teléfono móvil<span aria-hidden="true">*</span><span class="visually-hidden">(obligatorio)</span></label>
            <input type="tel" formControlName="Phone" id="Phone" class="form-control" [class.is-invalid]="submitted && reservationForm.get('Phone')?.invalid" [class.is-valid]="submitted && reservationForm.get('Phone')?.valid" placeholder="Teléfono móvil" maxlength="20" inputmode="tel" autocomplete="tel" pattern="(?:\+34|0034)?(?: |-)*[6-9](?:(?: |-)*[0-9]){8}" (input)="onPhoneInput($event)">
            @if (submitted && reservationForm.get('Phone')?.errors?.['required']) {
            <div class="invalid-feedback">Este campo es obligatorio</div>
            }
            @if (submitted && reservationForm.get('Phone')?.errors?.['pattern']) {
            <div class="invalid-feedback">Introduce un teléfono válido (9 dígitos, con prefijo opcional)</div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Dirección personal -->
    <div class="form-section labeled-section">
      <label class="form-label">Dirección personal<span aria-hidden="true">*</span><span class="visually-hidden">(obligatorio)</span></label>
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3">
            <label class="form-label">Dirección</label>
            <input type="text" formControlName="Address" class="form-control" [class.is-invalid]="submitted && reservationForm.get('Address')?.invalid" [class.is-valid]="submitted && reservationForm.get('Address')?.valid" placeholder="Dirección" maxlength="200">
            @if (submitted && reservationForm.get('Address')?.invalid) {
            <div class="invalid-feedback">Este campo es obligatorio</div>
            }
          </div>
        </div>
        <div class="col-md-4 col-xl-5">
          <div class="form-group mb-3">
            <label class="form-label">Localidad</label>
            <input type="text" formControlName="Location" class="form-control" [class.is-invalid]="submitted && reservationForm.get('Location')?.invalid" [class.is-valid]="submitted && reservationForm.get('Location')?.valid" placeholder="Localidad" maxlength="100">
            @if (submitted && reservationForm.get('Location')?.invalid) {
            <div class="invalid-feedback">Este campo es obligatorio</div>
            }
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="form-group mb-3">
            <label class="form-label">CP</label>
            <input type="text" formControlName="Cp" class="form-control" [class.is-invalid]="submitted && reservationForm.get('Cp')?.invalid" [class.is-valid]="submitted && reservationForm.get('Cp')?.valid" placeholder="CP" inputmode="numeric" maxlength="5" autocomplete="postal-code" pattern="(?:0[1-9]|[1-4][0-9]|5[0-2])[0-9]{3}" (input)="onPostalCodeInput($event)">
            @if (submitted && reservationForm.get('Cp')?.errors?.['required']) {
            <div class="invalid-feedback">Este campo es obligatorio</div>
            }
            @if (submitted && reservationForm.get('Cp')?.errors?.['pattern']) {
            <div class="invalid-feedback">Introduce un CP válido (5 dígitos)</div>
            }
          </div>
        </div>
        <div class="col-md-4 col-xl-5">
          <div class="form-group mb-3">
            <label class="form-label">Provincia</label>
            <input type="text" formControlName="Province" class="form-control" [class.is-invalid]="submitted && reservationForm.get('Province')?.invalid" [class.is-valid]="submitted && reservationForm.get('Province')?.valid" placeholder="Provincia" maxlength="100">
            @if (submitted && reservationForm.get('Province')?.invalid) {
            <div class="invalid-feedback">Este campo es obligatorio</div>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- DNI -->
    <div class="form-section labeled-section">
      <label class="form-label">DNI, adjunta foto del documento<span aria-hidden="true">*</span><span class="visually-hidden">(obligatorio)</span></label>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label class="form-label">Anverso del DNI</label>
            <ngx-dropzone class="rounded-0 mb-sm-2" [ngClass]="{'is-invalid': submitted && !selectedLicenseFiles}" id="dzLicenseFront" (change)="onFileLicenseFrontSelect($event)" accept="image/*" [multiple]="false">
              <ngx-dropzone-label class="bg-cropper_label">
                <div class="text-dark mb-3 lead">Anverso del DNI</div>
                <div class="mb-2">Arrastra el archivo para subirlo o</div>
                <div class="btn btn-outline-primary btn-sm">Seleccionar archivo</div>
              </ngx-dropzone-label>
              <ngx-dropzone-image-preview *ngFor="let f of licenseFrontFiles" [file]="f" [removable]="true" (removed)="onFileLicenseFrontRemove(f)">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-image-preview>
              @if (userInfo && licenseFrontFiles.length === 0 && userInfo.License1File) {
              <div class="custom-dropzone-image-preview">
                <img [src]="userInfo.License1File.FileUri" alt="Anverso del DNI">
              </div>
              }
            </ngx-dropzone>
            <div [ngClass]="{'d-block': submitted && !selectedLicenseFiles}" class="invalid-feedback">Debes adjuntar el DNI</div>
            @if (userInfo && userInfo.License1File) {
            <div class="actions_preview">
              <a [href]="userInfo.License1File.FileUri">Descargar <i class="fa-solid fa-download"></i></a>
            </div>
            }
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-3">
            <label class="form-label">Reverso del DNI</label>
            <ngx-dropzone class="rounded-0 mb-sm-2" [ngClass]="{'is-invalid': submitted && !selectedLicenseFiles}" id="dzLicenseBack" (change)="onFileLicenseBackSelect($event)" accept="image/*" [multiple]="false">
              <ngx-dropzone-label class="bg-cropper_label">
                <div class="text-dark mb-3 lead">Reverso del DNI</div>
                <div class="mb-2">Arrastra el archivo para subirlo o</div>
                <div class="btn btn-outline-primary btn-sm">Seleccionar archivo</div>
              </ngx-dropzone-label>
              <ngx-dropzone-image-preview *ngFor="let f of licenseBackFiles" [file]="f" [removable]="true" (removed)="onFileLicenseBackRemove(f)">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
              </ngx-dropzone-image-preview>
              @if (userInfo && licenseBackFiles.length === 0 && userInfo.License2File) {
              <div class="custom-dropzone-image-preview">
                <img [src]="userInfo.License2File.FileUri" alt="Reverso del DNI">
              </div>
              }
            </ngx-dropzone>
            <div [ngClass]="{'d-block': submitted && !selectedLicenseFiles}" class="invalid-feedback">Debes adjuntar el DNI</div>
            @if (userInfo && userInfo.License2File) {
            <div class="actions_preview">
              <a [href]="userInfo.License2File.FileUri">Descargar <i class="fa-solid fa-download"></i></a>
            </div>
            }
          </div>
        </div>
      </div>
      <div class="form-text mt-n2">
        Las imágenes deben estar en formato JPG, JPEG o PNG y tener un tamaño máximo de 2 MB.
      </div>

      @if (submitted && (!userInfo.License1File || !userInfo.License2File)) {
      <div class="invalid-feedback">Debes subir ambas fotos del DNI</div>
      }
    </div>

    <!-- Emisora de radio preferida -->
    <div class="form-section d-none">
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3">
            <label class="form-label">Emisora de radio preferida</label>
            <input type="text" formControlName="Radio" class="form-control" placeholder="Emisora de radio preferida" maxlength="100">
          </div>
        </div>
      </div>
    </div>

    <!-- Comentarios -->
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3">
            <label class="form-label">Comentarios</label>
            <textarea formControlName="Comments" class="form-control" placeholder="Comentarios" maxlength="500" rows="6"></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- Protección de datos -->
    <div class="form-section">
      <div class="row">
        <div class="col">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" role="switch" formControlName="dataProtection" id="dataProtection" class="form-check-input" [class.is-invalid]="submitted && reservationForm.get('dataProtection')?.invalid">
            <label class="form-check-label" for="dataProtection"><span>Acepto el tratamiento de mis datos.<span aria-hidden="true">*</span><span class="visually-hidden">(obligatorio)</span><br> <small>Consulta nuestra <a role="button" class="text-decoration-underline" data-bs-toggle="modal" data-bs-target="#privacyPolicyModal">política de protección de datos</a>.</small></span></label>
            @if (submitted && reservationForm.get('dataProtection')?.invalid) {
            <div class="invalid-feedback">Debes aceptar el tratamiento de tus datos</div>
            }
          </div>
        </div>
      </div>
      <div class="form-text mt-4">
        Todos los campos marcados con <span aria-hidden="true">*</span> son obligatorios. *
      </div>
      @if (submitted && (reservationForm.status === 'INVALID' || !selectedLicenseFiles)) {
      <div class="text-danger mt-3" animate.enter="loaded-height-enter" animate.leave="loaded-height-enter">
        Revisa que has completado todos los campos solicitados correctamente.
      </div>
      }
    </div>

    <!-- Botones -->
    <div class="reservation-footer-actions">
      <button type="button" class="btn btn-outline-primary btn-lg" (click)="onBack()">Volver</button>
      <button type="submit" class="btn btn-primary btn-lg">Finalizar mi reserva</button>
    </div>
  </form>
</div>